import type { ApiBody } from '../../../shared/api/contracts'
import type { SharedAccessPermissions } from '../../../shared/api/models'
import { apiGet, apiPost, apiPut } from './transport'

export async function fetchSharedAccessSummary(signal?: AbortSignal) {
  return apiGet<'GET /admin/shared-access'>('/admin/shared-access', signal)
}

export async function postSharedAccessInvite(data: ApiBody<'POST /admin/shared-access/invites'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/shared-access/invites'>('/admin/shared-access/invites', data, signal)
}

export async function postPreviewSharedAccessInvite(tokenOrCode: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/shared-access/invites/preview'>('/admin/shared-access/invites/preview', { tokenOrCode }, signal)
}

export async function postJoinSharedAccess(tokenOrCode: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/shared-access/join'>('/admin/shared-access/join', { tokenOrCode }, signal)
}

export async function postRevokeSharedAccessInvite(id: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/shared-access/invites/:id/revoke'>(`/admin/shared-access/invites/${encodeURIComponent(id)}/revoke`, {}, signal)
}

export async function postRevokeSharedAccess(accessId: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/shared-access/:accessId/revoke'>(`/admin/shared-access/${encodeURIComponent(accessId)}/revoke`, {}, signal)
}

export async function postLeaveSharedAccess(accessId: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/shared-access/:accessId/leave'>(`/admin/shared-access/${encodeURIComponent(accessId)}/leave`, {}, signal)
}

export async function putSharedAccessMemberPermissions(accessId: string, permissions: SharedAccessPermissions, signal?: AbortSignal) {
  return apiPut<'PUT /admin/shared-access/:accessId/permissions'>(
    `/admin/shared-access/${encodeURIComponent(accessId)}/permissions`,
    { permissions }, signal
  )
}
